module.exports = __webpack_public_path__ + "img/haijunlan.a755876c.png";